import React from "react";

const CLIENTS = [
    { src: "/assets/clients/monochrome/silicone-center.png", alt: "Silicone Center", h: 36, w: 152, prepared: true },
    { src: "/assets/clients/monochrome/andare-calcados.png", alt: "Andare Calçados", h: 42, w: 147, prepared: true },
    { src: "/assets/clients/monochrome/cartorio-itu.png", alt: "1º Cartório de Itu", h: 54, w: 127, prepared: true },
    { src: "/assets/clients/monochrome/coopertaxi-bh.png", alt: "Coopertáxi BH", h: 46, w: 139, prepared: true },
    { src: "/assets/clients/monochrome/coopertaxi-ms.png", alt: "Coopertaxi MS", h: 64, w: 63, prepared: true },
    { src: "/assets/clients/monochrome/rmc-radiotaxi.png", alt: "RMC Radiotaxi", h: 52, w: 127, prepared: true },
    { src: "/assets/clients/monochrome/drs-group.png", alt: "DRS Group", h: 66, w: 56, prepared: true },
    { src: "/assets/clients/monochrome/tlc-worldwide.png", alt: "TLC Worldwide", h: 62, w: 81, prepared: true },
    { src: "/assets/clients/monochrome/coe.png", alt: "COE Doenças e Tratamentos", h: 62, w: 97, prepared: true },
    { src: "/assets/clients/monochrome/vmg-farmaceutica.png", alt: "VMG Farmacêutica", h: 54, w: 114, prepared: true },
    { src: "/assets/clients/monochrome/vermont-xcenter.png", alt: "Vermont XCenter", h: 46, w: 146, prepared: true },
    { src: "/assets/clients/gondim.svg", alt: "Gondim", h: 34, w: 126 },
    { src: "/assets/clients/orient.svg", alt: "Orient", h: 34, w: 136 },
    { src: "/assets/partners/makeitsimple.svg", alt: "MakeITSimple", h: 29, w: 176 },
];

const OFFICIAL_PARTNERS = [
    { src: "/assets/partners/normalized/microsoft-partner.png", alt: "Microsoft Partner", className: "is-microsoft", w: 517, h: 245 },
    { src: "/assets/partners/normalized/openai-select-partner.png", alt: "OpenAI Select Partner", className: "is-openai", w: 464, h: 219 },
    { src: "/assets/partners/normalized/meta-tech-provider.png", alt: "Meta Tech Provider", className: "is-meta", w: 565, h: 441 },
    { src: "/assets/partners/normalized/elevenlabs-partner.png", alt: "ElevenLabs", className: "is-elevenlabs", w: 627, h: 81 },
    { src: "/assets/partners/normalized/inovabra.png", alt: "InovaBra - ecossistema de inovação Bradesco", className: "is-inovabra", w: 434, h: 165 },
];

const buildLoop = (items) => [...items, ...items, ...items];

const LogoStrip = () => (
    <section data-testid="logo-strip" className="zild-proof-logos">
        <div className="zild-proof-logos__clients">
            <div className="zild-container zild-proof-logos__head">
                <span>Clientes</span>
                <h2>Empresas que já operam com a Zild.</h2>
            </div>
            <ReferenceReel items={CLIENTS} />
        </div>

        <div className="zild-proof-logos__partners">
            <div className="zild-container">
                <div className="zild-proof-logos__partner-head">
                    <div>
                        <span>Parcerias oficiais</span>
                        <h2>Tecnologia e ecossistemas que ampliam nossa capacidade.</h2>
                    </div>
                    <p>Relacionamentos oficiais com provedores globais de IA e participação no ecossistema de inovação do Bradesco.</p>
                </div>
                <div className="zild-official-partners">
                    {OFFICIAL_PARTNERS.map((partner) => (
                        <div className={`zild-official-partner ${partner.className}`} key={partner.alt}>
                            <img src={partner.src} alt={partner.alt} loading="eager" decoding="async" width={partner.w} height={partner.h} />
                        </div>
                    ))}
                </div>
            </div>
        </div>

        <style>{`
            .zild-proof-logos { overflow: hidden; border-top: 1px solid var(--zild-border-soft); border-bottom: 1px solid var(--zild-border-soft); }
            .zild-proof-logos__clients { padding: 38px 0 34px; background: var(--zild-warm-paper); }
            .zild-proof-logos__head { margin-bottom: 24px; }
            .zild-proof-logos__head span, .zild-proof-logos__partner-head span { color: var(--zild-action); font-family: var(--zild-font-mono); font-size: 10px; letter-spacing: .1em; text-transform: uppercase; }
            .zild-proof-logos__head h2, .zild-proof-logos__partner-head h2 { margin: 8px 0 0; color: var(--zild-aubergine-ink); font-size: clamp(1.35rem, 2vw, 1.85rem); line-height: 1.18; }
            .zild-reference-reel { border-top: 1px solid var(--zild-border-soft); border-bottom: 1px solid var(--zild-border-soft); background: rgba(255,255,255,.42); }
            .zild-reference-reel__viewport { min-width: 0; overflow: hidden; padding: 12px 0; mask-image: linear-gradient(90deg, transparent, black 8%, black 92%, transparent); }
            .zild-reference-reel__track { display: flex; align-items: center; gap: 52px; width: max-content; animation: zildReferenceScroll 34s linear infinite; }
            .zild-reference-reel__item { flex: 0 0 auto; display: grid; place-items: center; min-width: 142px; height: 68px; }
            .zild-reference-reel__item img { display: block; width: auto; max-width: 176px; object-fit: contain; opacity: .86; filter: brightness(0) saturate(100%) invert(9%) sepia(29%) saturate(1264%) hue-rotate(135deg) brightness(94%) contrast(103%); }
            .zild-reference-reel__item.is-prepared img { filter: none; }

            .zild-proof-logos__partners { padding: 50px 0 56px; background: var(--zild-aubergine-nav); }
            .zild-proof-logos__partner-head { display: grid; grid-template-columns: 1fr minmax(300px, .65fr); gap: 50px; align-items: end; margin-bottom: 28px; }
            .zild-proof-logos__partner-head span { color: var(--zild-gold); }
            .zild-proof-logos__partner-head h2 { max-width: 640px; color: rgba(255,255,255,.95); }
            .zild-proof-logos__partner-head p { margin: 0; color: rgba(255,255,255,.62); font-size: 13px; line-height: 1.6; }
            .zild-official-partners { display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); gap: 10px; }
            .zild-official-partner { min-width: 0; height: 112px; display: grid; place-items: center; padding: 18px; border: 1px solid rgba(255,255,255,.12); border-radius: var(--zild-radius-md); background: rgba(255,255,255,.05); }
            .zild-official-partner img { display: block; width: auto; height: auto; max-width: 100%; max-height: 72px; object-fit: contain; }
            .zild-official-partner.is-openai img { max-width: 158px; max-height: 74px; transform: translateY(-3px); }
            .zild-official-partner.is-microsoft img { max-width: 124px; max-height: 58px; }
            .zild-official-partner.is-meta img { max-height: 62px; transform: scale(1.4); }
            .zild-official-partner.is-elevenlabs img { max-width: 166px; max-height: 32px; }
            .zild-official-partner.is-inovabra img { max-width: 142px; max-height: 54px; }

            @keyframes zildReferenceScroll { from { transform: translateX(0); } to { transform: translateX(-33.333%); } }
            @media (prefers-reduced-motion: reduce) {
                .zild-reference-reel__track { animation: none; width: 100%; flex-wrap: wrap; justify-content: center; gap: 24px; }
                .zild-reference-reel__item[aria-hidden="true"] { display: none; }
                .zild-reference-reel__viewport { mask-image: none; }
            }
            @media (max-width: 900px) { .zild-official-partners { grid-template-columns: repeat(3, 1fr); } }
            @media (max-width: 680px) { .zild-proof-logos__partner-head { grid-template-columns: 1fr; gap: 14px; } .zild-official-partners { grid-template-columns: 1fr 1fr; } .zild-official-partner { height: 96px; } }
        `}</style>
    </section>
);

const ReferenceReel = ({ items }) => (
    <div className="zild-reference-reel" aria-label="Clientes Zild">
        <div className="zild-reference-reel__viewport">
            <div className="zild-reference-reel__track">
                {buildLoop(items).map((item, index) => (
                    <div key={`${item.alt}-${index}`} className={`zild-reference-reel__item${item.prepared ? " is-prepared" : ""}`} aria-hidden={index >= items.length ? "true" : undefined}>
                        <img src={item.src} alt={index < items.length ? item.alt : ""} title={item.alt} loading="lazy" decoding="async" width={item.w} height={item.h} style={{ height: item.h, width: item.w }} />
                    </div>
                ))}
            </div>
        </div>
    </div>
);

export default LogoStrip;
